import type {ModalDialogService} from 'shared/modal-dialogs';
import type {StaticSearchParams} from 'src/typings';
import {transferify} from '../../utils/data-service-utils';
import type {SvelteComponentConstructor} from 'core/types';
import type { SearchSelectionModalModel } from 'src/modals/search-selection-modal/types';
import type {SelectableItem} from '../../../modals/search-selection-modal/types';

export default class SearchableValueEditorService {
    public static readonly serviceName = 'searchableValueEditorService';

    /*@ngInject*/
    constructor(private modalDialogService: ModalDialogService) {
    }

    public async searchAndSelectItem<MODEL>(notTransferifiedStaticSearchParams: StaticSearchParams, customComponent?: SvelteComponentConstructor<{value: SelectableItem, isSelected?: boolean}>): Promise<MODEL> {
        const modalModel: SearchSelectionModalModel = {
            staticSearchParams: transferify(notTransferifiedStaticSearchParams),
            customComponent
        };
        return await this.modalDialogService.openModalWindowAndGetPayload('searchSelection', modalModel) as MODEL;
    }
}